/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/GameModes/UnknownGameMode',['Solitaire/GameModes/GameModeBase',
        'Solitaire/GameModes/IGameMode',
        'Solitaire/SolitaireGameMode'],
    function (GameModeBase, IGameMode, SolitaireGameMode) {
        "use strict";

        var UnknownGameMode = function () {
            this.initUnknownGameMode();
        };

        UnknownGameMode.constructor = UnknownGameMode;
        UnknownGameMode.prototype = Object.create(GameModeBase.prototype);
        IGameMode.call(UnknownGameMode.prototype);

        UnknownGameMode.prototype.initUnknownGameMode = function () {
            this.TimerOption = IGameMode.TimerSettings.Off;
            this.Name = SolitaireGameMode.Unknown;
        };

        UnknownGameMode.prototype.GetGameEnd = function () {
            /*

             var model = new GameEndModel
             {
             LockIconSourcePath = "Assets/ui/icons/update.png",
             };
             model.UpdateStatistics = UpdateStatistics;
             return model;
             */

            return null; // TODO check this
        };

        UnknownGameMode.prototype.SetShare = function (args) {
            // ShareManager.ShareDefault(args); // TODO unsupported?
        };

        UnknownGameMode.prototype.GetStatKey = function () {
            // TODO
            return "Unknown";
            /*return new SolitaireStatistics.StatKey
             {
             GameMode = SolitaireGameMode.Unknown,
             Key = ""
             };*/
        };

        UnknownGameMode.UpdateStatistics = function (model) {
        };


        return UnknownGameMode;


    });
